import React from "react";
import { useParams } from "react-router-dom";

const TutorDetailPage = () => {
  const { tutorId, yearMonth } = useParams();

  const styles = {
    page: {
      padding: "1rem 0",
    },
    pageHeader: {
      marginBottom: "2rem",
    },
    pageHeaderH1: {
      fontSize: "1.875rem",
      fontWeight: "700",
      color: "#001272",
      marginBottom: "0.5rem",
    },
    pageHeaderP: {
      color: "#001272",
      opacity: "0.8",
      fontSize: "1rem",
    },
    content: {
      maxWidth: "800px",
    },
    infoCard: {
      background: "white",
      borderRadius: "0.5rem",
      boxShadow:
        "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
      padding: "2rem",
      border: "1px solid #f1f5f9",
    },
    infoCardH2: {
      fontSize: "1.5rem",
      fontWeight: "600",
      color: "#001272",
      marginBottom: "1.5rem",
    },
    infoCardP: {
      color: "#001272",
      opacity: "0.8",
      marginBottom: "2rem",
      lineHeight: "1.6",
    },
    section: {
      marginBottom: "2rem",
      paddingBottom: "1.5rem",
      borderBottom: "1px solid #f1f5f9",
    },
    sectionLast: {
      marginBottom: "0",
      paddingBottom: "0",
      borderBottom: "none",
    },
    sectionH3: {
      fontSize: "1.25rem",
      fontWeight: "600",
      color: "#001272",
      marginBottom: "1rem",
    },
    list: {
      color: "#001272",
      opacity: "0.8",
      marginBottom: "0",
      paddingLeft: "1.5rem",
      lineHeight: "1.6",
    },
    listItem: {
      marginBottom: "0.5rem",
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.pageHeader}>
        <h1 style={styles.pageHeaderH1}>Tutor Payroll Details</h1>
        <p style={styles.pageHeaderP}>
          Tutor ID: {tutorId} • Month: {yearMonth}
        </p>
      </div>

      <div style={styles.content}>
        <div style={styles.infoCard}>
          <h2 style={styles.infoCardH2}>Tutor Detail Page</h2>
          <p style={styles.infoCardP}>
            This page will show detailed payroll information for tutor {tutorId}{" "}
            for {yearMonth}:
          </p>

          <div style={styles.section}>
            <h3 style={styles.sectionH3}>Tutor Information</h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>Tutor name and contact details</li>
              <li style={styles.listItem}>Timezone and rate information</li>
              <li style={styles.listItem}>
                Employment status and contract details
              </li>
            </ul>
          </div>

          <div style={styles.section}>
            <h3 style={styles.sectionH3}>Payroll Summary</h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>Total hours worked</li>
              <li style={styles.listItem}>Hourly rate and gross income</li>
              <li style={styles.listItem}>Bonuses (night shift, etc.)</li>
              <li style={styles.listItem}>Deductions and penalties</li>
              <li style={styles.listItem}>Net pay calculation</li>
            </ul>
          </div>

          <div style={{ ...styles.section, ...styles.sectionLast }}>
            <h3 style={styles.sectionH3}>Line Items</h3>
            <ul style={styles.list}>
              <li style={styles.listItem}>
                Detailed breakdown of all appointments
              </li>
              <li style={styles.listItem}>Individual bonus calculations</li>
              <li style={styles.listItem}>Deduction details with reasons</li>
              <li style={styles.listItem}>
                Grouped by type (Tutoring, Bonuses, Deductions)
              </li>
            </ul>
          </div>

          <p style={styles.infoCardP}>Page implementation coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default TutorDetailPage;
